import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

export interface PasswordRuleStatus {
  length: boolean;
  lowercase: boolean;
  uppercase: boolean;
  digit: boolean;
  special: boolean;
  match: boolean;
}

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent implements OnChanges {

  @Input() public passwordToCheck: string;
  @Input() public confirmPasswordToCheck: string;
  @Output() passwordStrength = new EventEmitter<boolean>();
  rules: PasswordRuleStatus = {length: false, lowercase: false, uppercase: false, digit: false, special: false, match: false};

  ngOnChanges(): void {
    this.rules = this.evaluateRules(this.passwordToCheck || '', this.confirmPasswordToCheck || '');
    this.passwordStrength.emit(Object.values(this.rules).every(met => met));
  }

  private evaluateRules(password: string, confirmPassword: string): PasswordRuleStatus {
    return {
      length: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[^a-zA-Z0-9]/.test(password),
      match: password !== '' && password === confirmPassword
    };
  }

}
